import styled from '@emotion/styled';

const IconContainer = styled.span`
  position: absolute;
  margin: 1px 0 0 4px;

  svg {
    outline: none;
  }
`;

export default IconContainer;
